const AUTH_QUERY_PARAMS = [
  "auth",
  "tab",
  "phone",
  "email",
  "method",
  "attempt",
];

/**
 * Get clean callback URL for social auth, stripping any modal auth state
 * so that when the user returns from OAuth, the auth modal does not re-open.
 * @returns Clean callback URL for social auth
 */
export const getSocialCallbackUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }

  try {
    const url = new URL(window.location.href);
    AUTH_QUERY_PARAMS.forEach((param) => url.searchParams.delete(param));
    return url.toString();
  } catch {
    return window.location.origin;
  }
};

/**
 * Build social redirect URL safely
 * @param baseUrl Base URL for social auth endpoint
 * @returns Redirect URL with clean callback query parameter
 */
export const buildSocialHref = (baseUrl: string) => {
  if (!baseUrl) {
    return "#";
  }

  const callbackUrl = getSocialCallbackUrl();
  if (!callbackUrl) {
    return "#";
  }

  try {
    const url = new URL(baseUrl);
    url.searchParams.set("callback", callbackUrl);
    return url.toString();
  } catch (error) {
    console.error("[buildSocialHref] Failed to build social auth href:", error, { baseUrl });
    return "#";
  }
};
